// Sections of the account area, in header menu order. `href` mirrors
// UserPageLink: the settings section lives at /user, the rest at /user/<key>.
const ACCOUNT_SECTIONS = [
  { key: 'creations', label: 'My Projects', href: '/user/creations' },
  { key: 'trees', label: 'My Family Trees', href: '/user/trees' },
  { key: 'orders', label: 'Orders', href: '/user/orders' },
  { key: 'classic-orders', label: 'Classic Orders', href: '/user/classic-orders' },
  { key: 'credit', label: 'My Credit', href: '/user/credit' },
  { key: 'cards', label: 'Payment Methods', href: '/user/cards' },
  { key: 'settings', label: 'Personal Info', href: '/user' },
];

export default ACCOUNT_SECTIONS;
